"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavSidebar = exports.NavSidebarWrapper = exports.StyledNavSidebar = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const StyledNavSidebarWrapper = styled_components_1.default.div `
  width: var(--cobranding_layout_left_column_width);
  padding: var(--spacing-5);
  box-sizing: border-box;

  &.narrow {
    width: 320px;
  }

  &.lighter-bg {
    background: var(--gray-gray-70);
  }

  h1.title {
    display: flex;
    width: 100%;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1;
    padding: var(--spacing-5);
    cursor: default;
    align-items: center;
    @include typography.family-title;
    button {
      margin-right: 16px;
    }
  }
`;
exports.StyledNavSidebar = styled_components_1.default.nav `
  --cobrand--menu-item-background-color: #1F2630;

  display: block;
  & > a {
    font-family: var(--font-family-body);
    display: block;
    padding: var(--spacing-5);
    box-sizing: border-box;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1;
    color: var(--color-text-primary);
    cursor: pointer;
    text-decoration: none;
    transition: background-color 120ms ease-in-out;
    user-select: none;
    &:hover {
      background-color: var(--cobrand--menu-item-background-color, var(--color-black-300));
    }

    &.active {
      background-color: var(--cobrand--menu-item-background-color, var(--background-color-elevation));
      color: var(--color-text-white);
    }
    & > :global(span) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
`;
const NavSidebarWrapper = ({ dataTestId, className, title, children, }) => {
    return (react_1.default.createElement(StyledNavSidebarWrapper, { "data-testid": dataTestId, className: className },
        title && react_1.default.createElement("h1", { className: "title" },
            title,
            " "),
        children));
};
exports.NavSidebarWrapper = NavSidebarWrapper;
const NavSidebar = ({ items }) => {
    return (react_1.default.createElement(exports.NavSidebarWrapper, { title: null },
        react_1.default.createElement(exports.StyledNavSidebar, null, items.map(([path, item]) => (react_1.default.createElement(react_router_dom_1.NavLink, { key: path, to: path + window.location.search, activeClassName: "active", "data-testid": item.testid }, item.title))))));
};
exports.NavSidebar = NavSidebar;
//# sourceMappingURL=NavSidebar.js.map